import { getCustomDimensionsFromParams } from './ga4';
import { getTrackers, prependActionWithTrackerName } from './utils';

export {
  getTrackers,
  prependActionWithTrackerName,
  getCustomDimensionsFromParams,
};
